import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { CircularProgress, IconButton, IconButtonProps, Theme } from '@mui/material'

export type AsyncIconButtonProps = IconButtonProps & {
  loading: boolean
}

export const AsyncIconButton = React.forwardRef(
  ({ className, style, loading, ...otherProps }: AsyncIconButtonProps, _ref: any) => {
    const { classes } = useStyles()
    return (
      <div className={classNames(className, classes.iconContainer)} style={style}>
        {loading ? (
          <CircularProgress className={classes.loading} color="secondary" />
        ) : (
          <IconButton className={classNames(classes.button)} {...otherProps} />
        )}
      </div>
    )
  }
)

AsyncIconButton.displayName = 'AsyncIconButton'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  iconContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loading: {
    width: '100%',
    height: '100%',
    padding: spacing(),
  },
  button: {
    width: '100%',
    height: '100%',
  },
}))
